import { UserRole } from 'shared/types/userRole';

export function isDefined(role: UserRole | undefined): boolean {
  return Boolean(role);
}
